import { api } from './client.js';

/**
 * 도메인 모니터링 — 원본 partner.bananamall.co.kr/util/partners_report.php.
 *
 * 파트너 아이디를 붙여넣고 하루를 고르면 그 날의 유입·주문·가입·주문금액을
 * 파트너별로 센다. 자료는 파트너 DB(bananapartner, 서버 프로필 'ads')다.
 */
export interface PartnerReportRow {
  partnerId: string;
  /** 유입(클릭) 수 - CM_Click_NowData_<YYYYMM> */
  click: number;
  /** 주문 건수 - CM_Price_NowData_<YYYYMM> */
  order: number;
  /** 가입 수 - CM_Join_Data */
  join: number;
  /** 주문 금액 합계 */
  pay: number;
}

export interface PartnersReport {
  date: string;
  rows: PartnerReportRow[];
  /** 아이디를 못 읽은 줄이 아니라, 같은 아이디를 두 번 적은 경우를 접은 수. */
  duplicates: number;
}

export const partnersReportApi = {
  run: (date: string, text: string) =>
    api.post<PartnersReport>('/reports/partners-report', { date, text }),
};
